import { Stack, Typography } from '@mui/material'
import { EmptyIndicator, useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { VisitDataHeaderCard, VisitDataHeaderCardProps } from '../atoms/VisitDataHeaderCard'

type VisitDataHeaderAttributesCardProps = {
  attributes: {
    label: string
    maxWidth?: string
    value?: string | number | null
    icon?: React.ReactNode
  }[]
} & Pick<VisitDataHeaderCardProps, 'title' | 'width' | 'height' | 'warningText'>

export const VisitDataHeaderAttributesCard: FC<VisitDataHeaderAttributesCardProps> = observer(
  props => {
    const { attributes } = props
    const theme = useMinimalsTheme()

    return (
      <VisitDataHeaderCard {...props}>
        {attributes.map(attribute => (
          <Stack direction='column' key={attribute.label} width={'100%'}>
            <Typography
              variant='caption'
              color={theme.palette.text.secondary}
              whiteSpace={'nowrap'}
            >
              {attribute.label}
            </Typography>
            <Stack direction='row' alignItems='center' spacing={0.5}>
              {attribute.icon}
              <Typography
                variant='captionBold'
                whiteSpace={'nowrap'}
                overflow={'hidden'}
                textOverflow={'ellipsis'}
                maxWidth={attribute.maxWidth}
                title={attribute.value?.toString() ?? EmptyIndicator}
              >
                {attribute.value ?? EmptyIndicator}
              </Typography>
            </Stack>
          </Stack>
        ))}
      </VisitDataHeaderCard>
    )
  },
)
